// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';
import { MrText } from '@ion/components';
import { useFlags } from 'launchdarkly-react-client-sdk';

import BaseTable from '../../base-table/BaseTable';
import isFeatureEnabled from '../../../../launch-darkly/is-feature-enabled';
import { GatedConsentCategoriesSelect } from '../../../consent-categories-select/GatedConsentCategoriesSelect';

const ConsentCategoryTable = ({
  formState,
  setField,
  validateRequired,
  validateField,
  resetError,
  syncName,
  title = 'Consent Type',
  prefix = 'sync',
  helperText = undefined,
  addEmptyValue = false,
}) => {
  const consentCategorySelectName = `${prefix}-${syncName}-consentCategoryId`;
  const featureFlags = useFlags();
  const hasConsentModule = isFeatureEnabled({ featureFlags, flagName: 'ecmConfigurableConsent' });
  return (
    <BaseTable styleNames="noBorders">
      <tbody>
        <tr key={'consent-type'}>
          <td>
            <MrText
              styleNames="bold"
              component="span"
              required={Boolean(validateRequired && validateField && hasConsentModule)}
            >
              {title}
            </MrText>
          </td>
          <td>
            <GatedConsentCategoriesSelect
              errorMsg={formState[consentCategorySelectName]?.errorMsg}
              onChange={setField}
              value={formState[consentCategorySelectName]?.value}
              name={consentCategorySelectName}
              validators={validateRequired ? [validateRequired()] : undefined}
              onBlur={validateField || undefined}
              onInput={resetError}
              testId={`consentCategorySelect-${syncName}`}
              helperText={helperText || undefined}
              addEmptyValue={addEmptyValue}
              deprecatedSelect
            />
          </td>
        </tr>
      </tbody>
    </BaseTable>
  );
};

ConsentCategoryTable.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
  resetError: pt.func.isRequired,
  syncName: pt.string.isRequired,
  validateRequired: pt.func,
  validateField: pt.func,
  title: pt.string,
  prefix: pt.string,
  helperText: pt.string,
  addEmptyValue: pt.bool,
};
export default ConsentCategoryTable;
